// extracted by mini-css-extract-plugin
export default {"view":"ProjectList_view__rOYGn","archivedCheckbox":"ProjectList_archivedCheckbox__mn01A"};